var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFigmaDesignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9102_493774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 4.58268C4.16797 3.80913 4.47526 3.06727 5.02224 2.52029C5.56922 1.97331 6.31109 1.66602 7.08464 1.66602H10.0013V7.49935H7.08464C6.31109 7.49935 5.56922 7.19206 5.02224 6.64508C4.47526 6.0981 4.16797 5.35623 4.16797 4.58268Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602H12.9167C13.2997 1.66602 13.679 1.74146 14.0328 1.88803C14.3867 2.03461 14.7082 2.24945 14.9791 2.52029C15.2499 2.79112 15.4647 3.11266 15.6113 3.46652C15.7579 3.82039 15.8333 4.19966 15.8333 4.58268C15.8333 4.9657 15.7579 5.34498 15.6113 5.69884C15.4647 6.05271 15.2499 6.37424 14.9791 6.64508C14.7082 6.91591 14.3867 7.13075 14.0328 7.27733C13.679 7.42391 13.2997 7.49935 12.9167 7.49935H10V1.66602Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.4167C10 10.0336 10.0754 9.65437 10.222 9.30051C10.3686 8.94664 10.5834 8.62511 10.8543 8.35427C11.1251 8.08343 11.4466 7.86859 11.8005 7.72202C12.1544 7.57544 12.5336 7.5 12.9167 7.5C13.2997 7.5 13.679 7.57544 14.0328 7.72202C14.3867 7.86859 14.7082 8.08343 14.9791 8.35427C15.2499 8.62511 15.4647 8.94664 15.6113 9.30051C15.7579 9.65437 15.8333 10.0336 15.8333 10.4167C15.8333 10.7997 15.7579 11.179 15.6113 11.5328C15.4647 11.8867 15.2499 12.2082 14.9791 12.4791C14.7082 12.7499 14.3867 12.9647 14.0328 13.1113C13.679 13.2579 13.2997 13.3333 12.9167 13.3333C12.5336 13.3333 12.1544 13.2579 11.8005 13.1113C11.4466 12.9647 11.1251 12.7499 10.8543 12.4791C10.5834 12.2082 10.3686 11.8867 10.222 11.5328C10.0754 11.179 10 10.7997 10 10.4167V10.4167Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 16.2507C4.16797 15.4771 4.47526 14.7352 5.02224 14.1883C5.56922 13.6413 6.31109 13.334 7.08464 13.334H10.0013V16.2507C10.0013 17.0242 9.69401 17.7661 9.14703 18.313C8.60005 18.86 7.85818 19.1673 7.08464 19.1673C6.31109 19.1673 5.56922 18.86 5.02224 18.313C4.47526 17.7661 4.16797 17.0242 4.16797 16.2507Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 10.4167C4.16797 9.64312 4.47526 8.90125 5.02224 8.35427C5.56922 7.80729 6.31109 7.5 7.08464 7.5H10.0013V13.3333H7.08464C6.31109 13.3333 5.56922 13.026 5.02224 12.4791C4.47526 11.9321 4.16797 11.1902 4.16797 10.4167Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9102_493774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFigmaDesignIcon);
export default __webpack_public_path__ + "static/media/upload-figma-design-icon.f2c8c45294150ed62b27980998f44493.svg";
export { ForwardRef as ReactComponent };